export const BaseURL = "https://trademark-backend.aspsystems.kz"
